/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    negative: { type: 'variant', values: [ true ] },
    style: {
      description: 'Configure `style` variant for `ProgressBar`',
      type: 'variant',
      values: [ 'subtle', 'inverse', 'inactive', 'negative' ]
    }
  },
  rules: [
    {
      if: { inactive: true },
      tokens: { backgroundColor: '#c9c8c8', outlineColor: '#595959' }
    },
    {
      if: { negative: true },
      tokens: { backgroundColor: '#c9370b', outlineColor: '#595959' }
    },
    {
      if: { style: 'subtle' },
      tokens: {
        backgroundColor: '#666666',
        gradient: null,
        outlineColor: '#666666'
      }
    },
    {
      if: { style: 'inverse' },
      tokens: {
        backgroundColor: '#ffffff',
        gradient: null,
        outlineColor: '#ffffff'
      }
    },
    {
      if: { style: 'inactive' },
      tokens: { backgroundColor: '#c9c8c8', outlineColor: '#595959' }
    },
    {
      if: { style: 'negative' },
      tokens: { backgroundColor: '#c9370b', outlineColor: '#595959' }
    }
  ],
  tokens: {
    backgroundColor: '#000000',
    borderRadius: 12,
    gradient: null,
    outlineColor: '#595959',
    outlineWidth: 1,
    shadow: null
  }
}
export default theme
